import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider, applyTheme, initialThemeMode, resolveTheme } from './state/theme.js';
import { SessionProvider } from './state/session.js';
import { UIProvider } from './state/ui.js';
import { I18nProvider } from './i18n/context.js';
import { App } from './App.js';
import { SharedPage } from './components/SharedPage.js';
import { extractShareToken } from './lib/share.js';
import './styles/global.css';

// Apply the initial theme before first render to avoid flash
applyTheme(resolveTheme(initialThemeMode()));

const root = document.getElementById('root');
if (!root) throw new Error('#root element not found');
const shareToken = extractShareToken(window.location.pathname);

createRoot(root).render(
  <StrictMode>
    <ThemeProvider>
      <I18nProvider>
        {shareToken ? (
          <SharedPage />
        ) : (
          <SessionProvider>
            <UIProvider>
              <App />
            </UIProvider>
          </SessionProvider>
        )}
      </I18nProvider>
    </ThemeProvider>
  </StrictMode>,
);
